import { Check } from "lucide-react";
import { Reveal } from "./Reveal";

const ROMAN = ["I", "II", "III", "IV", "V"];

export default function Consulting({ services, content = {}, onBook }) {
  const tiers = services.filter((s) => s.section === "consulting");
  if (!tiers.length) return null;

  return (
    <section id="consulting" data-testid="consulting-section" className="bg-upland-brown text-upland-creme py-24 md:py-36">
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-upland-creme/60 mb-5">{content.consulting_overline || "Understand"}</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight max-w-3xl leading-tight">
            {content.consulting_title || "Business consulting tailored to where — and who — you are."}
          </h2>
          <p className="text-upland-creme/70 mt-6 max-w-xl text-lg leading-relaxed">
            {content.consulting_intro || "Every engagement begins with a holistic assessment to surface the barriers holding your business back. From there, choose the level of support that fits your needs."}
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {tiers.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.1}>
              <div data-testid={`consulting-tier-${i}`} className="h-full bg-upland-creme text-upland-green p-8 flex flex-col border-t-4 border-upland-green">
                <span className="font-serif text-5xl text-upland-brown/40 leading-none">{ROMAN[i]}</span>
                <h3 className="font-serif text-2xl md:text-3xl mt-4">{t.title.replace(/^Tier\s+[IVX]+\s*[—-]\s*/, "")}</h3>
                <p className="text-upland-brown text-sm tracking-wide mt-1">{t.tagline}</p>
                <p className="text-upland-grey mt-4 leading-relaxed flex-1">{t.description}</p>
                <ul className="mt-6 space-y-2.5">
                  {t.bullets?.map((b, bi) => (
                    <li key={bi} className="flex items-start gap-2.5 text-sm">
                      <Check size={16} className="mt-0.5 text-upland-green shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-12 text-center">
          <button data-testid="consulting-cta-btn" onClick={onBook}
            className="bg-upland-creme text-upland-green px-10 py-4 hover:bg-white transition-colors">
            Book a Consultation
          </button>
        </Reveal>
      </div>
    </section>
  );
}
